import { keyBy, get, isEmpty } from 'lodash';

// This function normalizes nested JSON using the nornmalizr pattern (https://github.com/paularmstrong/normalizr)
const normalizeCart = data => {
  const items = get(data, ['items']);

  const normalizedItems = keyBy(items, 'id');
  const itemEntities = isEmpty(items) ? {} : { item: normalizedItems };
  const itemKeys = Object.keys(normalizedItems);

  // Models cannot leverage the spread operator, so we have to manually do this
  const normalizedCart = {
    0: {
      id: data?.id,
      item_count: data?.item_count,
      total_price_with_currency: data?.total_price_with_currency,
      total_price: data?.total_price,
      attributes: data?.attributes,
      checkoutUrl: data?.checkoutUrl,
      items: itemKeys,
    },
  };

  const cartEntities = { cart: normalizedCart };

  const normalizedData = {
    entities: {
      ...cartEntities,
      ...itemEntities,
    },
    result: 0, // Cart id is always zero :)
  };

  return normalizedData;
};

export default normalizeCart;
